let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8HU45")).then(() => parcelRequire('Di7Ct'));